import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"

interface BonusOpDisplayApiRoleCOnf {
  getDetailsEndpoint: (operationId: string) => string
  getSummaryEndpoint: (operationId: string) => string
  getParticipantListEndpoint: (operationId: string) => string
}

const presidentApiRoleConf = {
  getDetailsEndpoint: (operationId: string) =>
    `/api/operation/bonus/upp/${operationId}`,
  getSummaryEndpoint: (operationId: string) =>
    `/api/operation/bonus/upp/${operationId}/summary`,
  getParticipantListEndpoint: (operationId: string) =>
    `/api/operation/bonus/upp/${operationId}/participations`,
}

export const apiRoleConf: RoleStrategy<BonusOpDisplayApiRoleCOnf> = {
  [ROLES.ADMIN]: {
    getDetailsEndpoint: () => "",
    getSummaryEndpoint: () => "",
    getParticipantListEndpoint: (operationId) =>
      `/api/operation/bonus/${operationId}/participations`,
  },
  [ROLES.UPP_PRESIDENT]: presidentApiRoleConf,
  [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf,
  [ROLES.ADHERENT_HOLDER]: {
    getDetailsEndpoint: (operationId) =>
      `/api/operation/bonus/adherent/${operationId}`,
    getSummaryEndpoint: (operationId) =>
      `/api/operation/bonus/upp/${operationId}/summary`,
    getParticipantListEndpoint: () => "",
  },
}
